import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/BaseMapApi/';

// 根据底图ID查询关联的全部数据（视频、影像、线索区、区域名录）
export const getRelatedData = (baseMapId) => {
  return getInterface.post(`${prefixUrl}getRelatedData/${baseMapId}`, {});
}

// 删除底图关联的数据
export const removeBaseMapData = (data) => {
  return getInterface.post(`${prefixUrl}removeData`, data);
}
